import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api/client';
import i18n from '../i18n';

const AuthContext = createContext(null);
const SUPPORTED_LANGS = ['es', 'en', 'de'];

function browserLang() {
  const raw = (navigator.language || '').slice(0, 2).toLowerCase();
  return SUPPORTED_LANGS.includes(raw) ? raw : null;
}

function applyUserLanguage(lang, idioma_personalizado) {
  if (idioma_personalizado) {
    if (lang && SUPPORTED_LANGS.includes(lang)) {
      i18n.changeLanguage(lang);
      try { localStorage.setItem('colmena_lang', lang); } catch {}
    }
  } else {
    const preferred = browserLang()
      || ((() => { try { return localStorage.getItem('colmena_lang'); } catch { return null; } })())
      || 'en';
    const effective = SUPPORTED_LANGS.includes(preferred) ? preferred : 'en';
    i18n.changeLanguage(effective);
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authAPI.me()
        .then(r => { setUser(r.data); applyUserLanguage(r.data.language, r.data.idioma_personalizado); })
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await authAPI.login(email, password);
    localStorage.setItem('token', r.data.access_token);
    const me = await authAPI.me();
    setUser(me.data);
    applyUserLanguage(me.data.language, me.data.idioma_personalizado);
    return me.data;
  };

  const register = async (data) => {
    await authAPI.register(data);
    return login(data.email, data.password);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('colmena_asistente_analisis');
    localStorage.removeItem('colmena_asistente_generado');
    localStorage.removeItem('colmena_asistente_respuesta');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
